import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Row, CardImg, Modal, ModalHeader, ModalBody, Tooltip } from 'reactstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { dAPI_Delete_Ingetration, putAPI_Update_OnOff } from '../../../../../../constants/APIs';
import MewsIntegration from './MewsIntegration';
import Mews_Logo from '../../../../../../assets/mews_logo.jpg';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
export default function MewsIntegrationThumb({ integration, allProperties, LoadIntegrations }) {

    const [deleteVisible, setDeleteVisible] = useState(false);
    const [formatedProperties, setFormatedProperties] = useState('');
    const [moreProperties, setMoreProperties] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
        !integration.disabled
    );
    useEffect(() => {
        const result = integration.properties.map(id => {
            return allProperties.find(elem => elem.id === id);
        });
        if (result.length > 2) {
            const filterResults = result.slice(0, 2);
            setFormatedProperties(filterResults.map(elem => elem?.name).join(", "));
            setMoreProperties('and ' + (result.length - filterResults.length) + ' more')
        }
        else {
            const filterResults = result.filter(elem => elem !== undefined);
            setFormatedProperties(filterResults.map(elem => elem?.name).join(", "));

        }
    }, [integration, allProperties]);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
        }).then(res => {
            toggle();
            LoadIntegrations();
        });
    };
    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This action will permanently remove the integration. Are you sure you want to delete the integration?
                                </ModalHeader>
                                <ModalBody className="d-flex justify-content-space-between">
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Confirm
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleOnOff = (onoff) => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
            data: { disabled: onoff },
        }).then((res) => {
        });
    };
    const handleSwitchChange = (value) => {
        //console.log(value)
        setCheckedPrimarySmall(value);
        handleOnOff(!value);
    };
    return (
        <Fragment>
            {integration ? <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card className="d-flex flex-row" style={{ height: '215px' }}>
                    <div>
                        <h3 className="integrationChannel">
                            <img
                                src={Mews_Logo}
                                alt="Logo"
                                style={{ maxWidth: '100px' }}
                            />
                        </h3>
                        {/* <a href="#/" className="integrationremove"
                        onClick={toggle}
                    >
                        {" "}
                        <h3 className="iconsminds-remove" />{" "}
                    </a> */}
                        <Switch
                            className="agentswitch  custom-switch-primary custom-switch-small integrationremove"
                            checked={checkedPrimarySmall}
                            onChange={(primary) => handleSwitchChange(primary)}
                        /></div>
                    <CardBody>
                        <Row>
                            <Colxx xxs="12" className="mb-3">
                                <div className="text-center">
                                    <div className="mb-1">
                                        {integration.name}
                                    </div>
                                    <div className="mb-2">
                                        <b>{formatedProperties} </b>
                                        <b>{moreProperties}</b>
                                    </div>
                                    <Button
                                        size="xs"
                                        color="success"
                                        outline
                                        style={{ marginTop: '20px', display: 'inline-block' }}
                                        onClick={() => setIsEditing(!isEditing)}
                                    >
                                        Edit
                                    </Button>
                                </div>
                            </Colxx>
                        </Row>
                    </CardBody>
                    <div className='integrationdelete'>
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            style={{ color: 'var(--theme-color-1)' }}
                            cursor="pointer"
                            onClick={toggle}
                        />
                    </div>
                </Card>
            </Colxx> : null
            }
            {
                isEditing ? (
                    <Row>
                        <Colxx xxs="12">
                            <Row>
                                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                                <Colxx md="4" sm="4" lg="4" xxs="12">
                                    <MewsIntegration
                                        visible={isEditing}
                                        toggle={() => {
                                            setIsEditing(!isEditing);
                                        }}
                                        id={integration.id}
                                    />
                                </Colxx>
                                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                            </Row>
                        </Colxx>
                    </Row>
                ) : null
            }
            {generateDeleteButton()}
        </Fragment >
    );
}
